import { ReactElement, useEffect, useState } from 'react';
import ReactDataSheet from 'libs/react-datasheet';
import Spinner from 'shared/feedback/Spinner';

/**
 * Use this instead of ReactDataSheet so that if the amount of data is large
 * it will show a loader while the component is building.
 *
 * NOTE (restructure dedup, GABY): intentionally NOT merged with StyledDataSheet.
 * This is the low-level deferred-render wrapper around the raw `react-datasheet`
 * lib; StyledDataSheet is the tag/styling-aware sheet built on top of it (it
 * renders a DelayedDataSheet internally). Different layers, different purpose —
 * the two are irreconcilable by design.
 */
export function DelayedDataSheet(props: Record<string, unknown>): ReactElement {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setReady(true), 0);
    return () => clearTimeout(timer);
  }, []);

  return ready ? <ReactDataSheet {...props} /> : <Spinner />;
}
